import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'

export class VaultAbout extends Component { 
  componentDidMount() {
    this.props.selectMode('integration_guide')
  }

  state = {
    isSubmitClicked: false
  }

  render() {

    return (
      <div className="stepPageContainer">  
          <h3 className="stepPageTitle">About the Vault Transaction Set</h3>
          <p>The Vault feature allows merchants to create customer profiles, edit those profiles, and use them to process
          transactions without having to enter financial information each time. Customer profiles store customer
          data essential to processing transactions, including credit and signature debit.
          The Vault is a complement to the Recurring Billing module. It securely stores customer account information
          on Moneris secure servers. This allows merchants to bill customers for routine products or services
          when an invoice is due.
          </p>  
      </div>
    )
  }
}



const mapStateToProps = state => {
  const {mode} = state.common.sideNav;
  return { mode};
}

export default connect(mapStateToProps, { selectMode})(VaultAbout)



